module.exports = __webpack_public_path__ + "img/ed104d8c-7f39-4e8b-90a9-4076be06b857.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/ed104d8c-7f39-4e8b-90a9-4076be06b857.svg
// module id = 182
// module chunks = 245 246